import CustomerView from 'models/location/customer_view';
import Err from 'models/err';
import ExternalAppCardData from 'models/external_apps/external_app_card_data';

/**
 * InvalidateAppCardData goes through all loaded customer stores and invalidates
 * all loaded External App Card data. For the current customer, the data is marked
 * as "stale" (to minimize the card flickering) and for the rest of the customers,
 * the External App Card data store is cleared altogether.
 */
export default class InvalidateAppCardData {
  constructor(context) {
    this.context = context;
  }

  run() {
    const allCustomerIds = this.context.stores.customers.getAllCustomerIds();
    const currentLocation = this.context.stores.currentLocation.get();

    let currentCustomerId = '';
    if (currentLocation instanceof CustomerView) {
      currentCustomerId = currentLocation.customerId;
    }

    allCustomerIds.forEach(id => {
      const store = this.context.stores.customers.storesFor(id).externalAppCardData;
      if (id === currentCustomerId) {
        const entities = store.findAll();
        const updatedEntities = entities.map(dto => {
          const { errors, ...rest } = dto;
          const errorEntities = (errors || []).map(err => new Err(err));

          return ExternalAppCardData.create({
            ...rest,
            errors: errorEntities,
            isStale: true,
          });
        });

        store.set(updatedEntities);
      } else {
        store.set([]);
      }
    });
  }
}
